import React, { useCallback, useContext, useEffect, useState } from 'react'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { initialPage, initialPageSize } from 'keys/pagination'
import { getAllTestTakersFetch, getTestTakersFetch } from 'store/middlewares/testTakers.crud'
import { schoolHooks } from '.'
import { Table } from 'components'
import { isEmpty } from 'lodash'
import { LightButton } from 'styles/GlobalStyle'
import { useParams } from 'react-router-dom'
import qc from 'keys/queryClient'
import { Can } from 'components/Permissions'
import { AutoComplete } from 'components/Form'
import { dataGridModel } from 'keys'
import { SchoolContext } from './SchoolContext'

const TestTakers = (props) => {
    const {
        tClass,
        invalidTestTakers,
        affiliation,
        grades,
        grade,
        learningUnitKey,
        learningUnit
    } = props

    const [page, setPage] = useState(initialPage)
    const [rowOpen, setRowOpen] = useState(null)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")
    const { affiliationID } = useParams()

    const { promoteSelection, setPromoteSelection, promoteSelectedGradeId, setPromoteSelectedGradeId, classStudentsCache, setClassStudentsCache } = useContext(SchoolContext)

    const onPromoteSelectionChange = useCallback((next) => {
        let updated = next
        if (learningUnit?.id && promoteSelection[learningUnit.id]) {
            const classStudentIds = classStudentsCache[learningUnit.id] || []
            const stillAllSelected = classStudentIds.length && classStudentIds.every(id => next[id])
            if (!stillAllSelected) {
                updated = { ...next }
                delete updated[learningUnit.id]
            }
        }
        setPromoteSelection(updated)
        setPromoteSelectedGradeId(Object.keys(updated).length ? (promoteSelectedGradeId || grade) : null)
    }, [promoteSelectedGradeId, grade, learningUnit, promoteSelection, classStudentsCache])

    const canSelectStudentRow = useCallback(() =>
        !promoteSelectedGradeId || grade == promoteSelectedGradeId
        , [promoteSelectedGradeId, grade])

    const classHeaderBtns = schoolHooks.useClassHeaderBtns(learningUnit, learningUnitKey)
    const testTakerTableColumns = schoolHooks.useTestTakerTableColumns()

    const testTakersOptions = queryOptions({
        queryKey: [qc.testTakers, affiliationID, learningUnit?.id],
        queryFn: async () => {
            const { data } = await getAllTestTakersFetch({ [learningUnitKey]: learningUnit?.id })
            return data
        },
        enabled: !!learningUnit?.id
    })
    const testTakers = useQuery(testTakersOptions)

    useEffect(() => {
        if (!learningUnit?.id || !testTakers.data?.length) return

        const studentIds = testTakers.data.map(st => st.id)
        setClassStudentsCache(prev =>
            prev[learningUnit.id]?.length === studentIds.length ? prev :
                { ...prev, [learningUnit.id]: studentIds }
        )

        if (promoteSelection[learningUnit.id]) {
            const missing = studentIds.some(id => !promoteSelection[id])
            if (missing) {
                const next = { ...promoteSelection }
                studentIds.forEach(id => { next[id] = true })
                setPromoteSelection(next)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [learningUnit?.id, testTakers.data])

    const data = invalidTestTakers.concat(testTakers.data || [])

    return (
        <div className='class'>
            <div className='class-header'>
                <div className='class-details'>
                    <div className='num-students'>{`${testTakers.data?.length || 0} תלמידים`}</div>
                    <div>
                        {"מורה:"}
                        {/* <AutoComplete
                            options={users}
                            input={{

                            }}
                        /> */}
                    </div>
                    {classHeaderBtns.map((btn, index) =>
                        <Can I={btn.role} a={btn.feature}>
                            {btn.component ?
                                <btn.component
                                    key={index}
                                    {...btn}
                                /> :
                                <LightButton
                                    key={index}
                                    {...btn}
                                />}
                        </Can>
                    )}
                </div>
                {!invalidTestTakers.length ||
                    <div className='invalid-students-alert'>
                        {`שימו לב: התלמידים (${invalidTestTakers.length}) הצבועים באדום לא נכנסו למערכת!`}
                        <div>{"חסרים להם נתונים בסיסיים."}</div>
                    </div>
                }
            </div>
            {!testTakers.isFetching && isEmpty(data) ?
                <div className='empty-class'>{"לא הוגדרו תלמידים לכיתה זו"}</div> :
                <Table
                    withTitle
                    loading={false}
                    data={{ results: data || [] }}
                    columns={testTakerTableColumns}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    rowOpen={rowOpen}
                    setRowOpen={setRowOpen}
                    hidePagination
                    hideSorting
                    hideToolbar
                    searchVal={searchVal}
                    setSearchVal={setSearchVal}
                    visibilityModelKey={dataGridModel.affiliation_test_takers}
                    sorting={sorting}
                    setSorting={setSorting}
                    queryKey={testTakersOptions.queryKey}
                    selectedRowIds={promoteSelection}
                    setSelectedRowIds={onPromoteSelectionChange}
                    onRowSelection={onPromoteSelectionChange}
                    canSelectRow={canSelectStudentRow}
                />}
        </div>
    )
}

export default TestTakers